import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { visuallyHidden } from "@mui/utils";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../UiComponents/ConfirmBox/ConfirmBox";
import { ToastError } from "../../UiComponents/Toaster/Toast";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  AccountBalanceWalletIcon,
  SearchIcon,
  EditIcon,
  DownloadIcon,
  CloudOffIcon,
  RestartAltIcon,
} from "../../Resources/Icons/icons";
import moment from "moment";
import ManageWallet from "./ManageWallet";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import {
  GetCompanyWallet,
  DeleteBranch,
  GetCompany,
  GetBookingCode,
  GetSubBookingCode,
  GetPolicyFindbyId,
  FilterPolicyList,
  GetUser,
  GetUserWallet,
  ReframeEndDateTimeFormat,
} from "../../Service/_index";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import CommonPayableDrawer from "../CommonPayableDrawer/CommonPayableDrawer";
import { PolicyFilterTypes } from "../../Shared/CommonConstant";
import Loader from "../../UiComponents/Loader/Loader";
import { DatePicker, Radio } from "antd";
import { CSVLink } from "react-csv";
import { useEffect } from "react";
import filterr from "../../Resources/Images/filter-lines.png";
import exportt from "../../Resources/Images/export.png";
import { Divider, Stack, Badge } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import MasterCommonTable from "../../UiComponents/CommonTable/MasterCommonTable";
import FilterBox from "../../UiComponents/FilterBox/FilterBox";
import CustomButton from "../../UiComponents/CommonBUtton/ConfirmBox";
import wallett from "../../Resources/Images/wallet.png";
const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "bookingCode",
    numeric: true,
    disablePadding: false,
    label: "Booking Code",
  },
  {
    id: "subBookingCode",
    numeric: true,
    disablePadding: false,
    label: "Sub Booking Code",
  },
  {
    id: "totalCommisionPayable",
    numeric: true,
    disablePadding: false,
    label: "Commision Payable",
  },
  {
    id: "action",
    placeMent: false,
    disablePadding: false,
    label: "Action",
  },
];

const EnhancedTableHead = (props) => {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.numeric ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const CompanyWallet = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [wallet, setWallet] = React.useState([]);
  const [subBookingCode, setSubBookingCode] = useState("");
  const [openLoader, setOpenLoader] = useState(false);
  const [formType, setFormType] = useState("");
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [resetValue, setResetValue] = useState(1);
  const [filterType, setFilterType] = useState();
  const [selectedItems, setSelectedItems] = useState(null);
  const [userDetails, setUserDetails] = useState([]);
  const [totalWallet, setTotalWallet] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [dateRange, setDateRange] = useState();
  const [value, setValue] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isSearch: true,
    isApprove: true,
    isMultiDelete: false,
    type: "branchWallet",
  });
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  // defined by gokul....

  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]);
  const [subBookingCodeValue, setSubBookingCodeValue] = useState(null);
  const [bookingCodeValue, setBookingCodeValue] = useState(null);
  const [bookingCode, setBookingCode] = useState(null);
  const [bookingCodeId, setBookingCodeId] = useState();
  const [booking, setBooking] = useState("");
  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(wallet), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, wallet]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const GetUserDetails = async () => {
    setOpenLoader(true);
    try {
      const res = await GetUser({ isAscending: true });
      setOpenLoader(false);

      const modifiedUserDetails = res?.data.map((e) => {
        return {
          ...e,
          label: e.name,
          value: e._id,
        };
      });

      setUserDetails(modifiedUserDetails);
    } catch (error) {
      setOpenLoader(false);

      console.error(error);
    }
  };

  useEffect(() => {
    GetUserDetails();
  }, []);

  const handleMultiDelete = (items) => {
    setSelectedItems(items);
  };

  const calculateSum = (arr) => {
    return arr?.reduce((total, current) => {
      return Number(total) + Number(current);
    }, 0);
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items?.filter((el) =>
            `${el?.subBookingCode},${el?.bookingCode},${el.totalCommisionPayable}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
  };

  const [endDate, setEndDate] = useState(null);

  // Helper function to extract ID from various formats
  const getBookingCodeId = (bookingValue) => {
    if (!bookingValue) return null;
    if (typeof bookingValue === "string") return bookingValue;
    if (bookingValue._id) return bookingValue._id;
    if (bookingValue.value) return bookingValue.value;
    return bookingValue;
  };

  // Helper function to extract Sub Booking Code Name (label) from _id
  const getSubBookingCodeName = (subBookingValue) => {
    if (!subBookingValue) return null;

    // Extract the _id from various formats
    let subBookingId = null;
    if (typeof subBookingValue === "string") {
      subBookingId = subBookingValue;
    } else if (subBookingValue._id) {
      subBookingId = subBookingValue._id;
    } else if (subBookingValue.value) {
      subBookingId = subBookingValue.value;
    } else {
      subBookingId = subBookingValue;
    }

    // Find the sub booking code object by _id and return the label (name)
    const subBookingCodeObj = subBookingCodeDetails.find(
      (item) => item._id === subBookingId || item.value === subBookingId
    );

    // If not found in subBookingCodeDetails, try subBookingCode (if it's an array)
    if (!subBookingCodeObj && Array.isArray(subBookingCode)) {
      const subBookingObj = subBookingCode.find(
        (item) => item._id === subBookingId || item.value === subBookingId
      );
      return subBookingObj?.label || subBookingObj?.subBookingCode || null;
    }

    return (
      subBookingCodeObj?.label || subBookingCodeObj?.subBookingCode || null
    );
  };

  const GetData = async () => {
    setOpenLoader(true);
    // let endDate = null;
    if (selectedEndDate) {
      const eDate = await ReframeEndDateTimeFormat(selectedEndDate);
      setEndDate(eDate);
    }
    GetCompanyWallet({
      bookingCodeId: getBookingCodeId(booking),
      subBookingCodeId: getSubBookingCodeName(subBookingCodeValue),
      startDate: selectedStartDate,
      endDate: endDate,
    })
      .then((res) => {
        setOpenLoader(false);
        const FilteredWallet =
          res?.data
            ?.filter((e) => e?.totalCommisionPayable !== 0)
            ?.map((row) => ({
              ...row,
              action: (
                <Button onClick={() => StateMentFunction(row)}>
                  Statement
                </Button>
              ),
            })) || [];
        setWallet(FilteredWallet);
        const totalWalletValues =
          res?.data?.map((e) => e?.totalCommisionPayable) || [];
        setTotalWallet(totalWalletValues);
        setPage(0);
      })
      .catch((err) => {
        setOpenLoader(false);
        setWallet([]);
        setTotalWallet([]);
        console.log("err");
      });
  };

  const ResetFilter = () => {
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setResetValue(resetValue + 1);
    setWallet([]);
  };

  const header = [
    { label: "Booking Code", key: "bookingCode" },
    { label: "SubBooking Code", key: "subBookingCode" },
    { label: "Commission Payable", key: "totalCommisionPayable" },
  ];
  const csvFile = {
    filename: "Company Wallet Data",
    headers: header,
    data: wallet,
  };
  const FilterOptions = [
    {
      label: "Daily Payout",
      value: "Daily",
    },
    {
      label: "Weekly Payout",
      value: "Weekly",
    },
    {
      label: "Monthly Payout",
      value: "Monthly",
    },
    {
      label: "All Payout",
      value: "All",
    },
  ];

  // Written by gokul...
  const getBookingCodeFunct = () => {
    GetBookingCode({ isAscending: true }).then((res) => {
      const modifiedBookingCodeDetails = res?.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.bookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);

      setBookingCodeDetails(modifiedBookingCodeDetails);
    });
  };

  const getSubBookingCodeFunct = () => {
    GetSubBookingCode({ isAscending: true }).then((res) => {
      const modifiedSubBookingCodeDetails = res?.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.subBookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);

      const FilterSubBookingCodeDetails = modifiedSubBookingCodeDetails?.filter(
        (item) => item.bookingCodeId === booking
      );
      setSubBookingCode(FilterSubBookingCodeDetails);
      setValue(FilterSubBookingCodeDetails?.[0]?.label);
      setSubBookingCodeDetails(FilterSubBookingCodeDetails);
    });
  };

  const StateMentFunction = (row) => {
    setSelectedData([row]);
    setOpenDrawer(true);
  };

  useEffect(() => getBookingCodeFunct(), []);

  const filterBoxData = [
    {
      id: 1,
      label: "Select Booking Code",
      data: bookingCodeDetails,
      setState: setBooking,
      value: booking,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Select SubBooking Code",
      data: subBookingCode,
      setState: setSubBookingCodeValue,
      value: subBookingCodeValue,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Select Date",
      setDate: (range) => {
        setDateRange(range);
        setSearchTrigger((prev) => prev + 1);
      },
      type: "noDefaultDate",
    },
  ];

  useEffect(() => {
    const handleDateChange = (dateRange) => {
      if (dateRange && Array.isArray(dateRange)) {
        setSelectedStartDate(dateRange ? dateRange[0] : null);
        setSelectedEndDate(dateRange ? dateRange[1] : null);
      } else {
        setSelectedStartDate(null);
        setSelectedEndDate(null);
      }
    };
    handleDateChange(dateRange);
  }, [dateRange]);

  const activeFiltersCount = (() => {
    let count = 0;
    if (dateRange && Array.isArray(dateRange) && dateRange.length === 2)
      count += 1;
    if (booking) count += 1;
    if (subBookingCodeValue) count += 1;
    return count;
  })();

  useEffect(() => {
    getSubBookingCodeFunct();
  }, [booking]);

  const handleClearAllState = () => {
    setSubBookingCodeValue(null);
    setBookingCode(null);
    setBooking(null);
    setValue(null);
    setDateRange(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    // Call API with all filters cleared
    GetData();
  };

  const handleClearSingleFilter = async (filterId) => {
    if (filterId === 1) {
      // Clear booking code filter - this also clears sub booking code
      setBooking(null);
      setBookingCode(null);
      setSubBookingCodeValue(null);
      setValue(null);
      // Call API with all filters cleared (unfiltered data)
      setOpenLoader(true);
      let endDateFormatted = null;
      if (selectedEndDate) {
        endDateFormatted = await ReframeEndDateTimeFormat(selectedEndDate);
      }
      GetCompanyWallet({
        bookingCodeId: null, // No booking code filter
        subBookingCodeId: null, // No sub booking code filter
        startDate: selectedStartDate,
        endDate: endDateFormatted,
      })
        .then((res) => {
          setOpenLoader(false);
          const FilteredWallet = res?.data
            ?.filter((e) => e?.totalCommisionPayable !== 0)
            ?.map((row) => ({
              ...row,
              action: (
                <Button onClick={() => StateMentFunction(row)}>
                  Statement
                </Button>
              ),
            }));
          setWallet(FilteredWallet || []);
          const totalWalletValues =
            res?.data?.map((e) => e?.totalCommisionPayable) || [];
          setTotalWallet(totalWalletValues);
          setPage(0);
        })
        .catch((err) => {
          setOpenLoader(false);
          setWallet([]);
          setTotalWallet([]);
          console.log("err");
        });
    } else if (filterId === 2) {
      // Clear sub booking code filter - show data with booking code only
      setSubBookingCodeValue(null);
      setValue(null);
      // Call API with booking code only (subBookingCodeId as null)
      setOpenLoader(true);
      let endDateFormatted = null;
      if (selectedEndDate) {
        endDateFormatted = await ReframeEndDateTimeFormat(selectedEndDate);
      }
      GetCompanyWallet({
        bookingCodeId: getBookingCodeId(booking), // Keep booking code ID
        subBookingCodeId: null, // Explicitly pass null for sub booking code
        startDate: selectedStartDate,
        endDate: endDateFormatted,
      })
        .then((res) => {
          setOpenLoader(false);
          const FilteredWallet = res?.data
            ?.filter((e) => e?.totalCommisionPayable !== 0)
            ?.map((row) => ({
              ...row,
              action: (
                <Button onClick={() => StateMentFunction(row)}>
                  Statement
                </Button>
              ),
            }));
          setWallet(FilteredWallet);
          const totalWalletValues = res?.data.map(
            (e) => e?.totalCommisionPayable
          );
          setTotalWallet(totalWalletValues);
          setPage(0);
        })
        .catch((err) => {
          setOpenLoader(false);
          console.log("err");
        });
    } else if (filterId === 3) {
      // Clear date filter
      setDateRange(null);
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      // Call API with cleared dates
      GetData();
    }
  };

  const [searchTrigger, setSearchTrigger] = useState(0);

  const handleSaveAllFilter = () => {
    setSearchTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    if (searchTrigger > 0) {
      GetData();
    }
  }, [searchTrigger]);

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* Filter area toggled via Filters button */}
          {/* Table container below filter */}
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems="center"
                className="Master_Card_Sub_Container"
                spacing={2}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Typography className="Master_Card_Tittle">
                    Company Wallet
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  sx={{
                    display: "flex",
                    justifyContent: { md: "flex-end", sm: "flex-end" },
                  }}
                  gap={"8px"}
                >
                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{ alignItems: "center" }}
                  >
                    <Button
                      className="Master_Card_Filter_Button"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter(!showFilter)}
                      size="small"
                      variant="outlined"
                    >
                      Filters
                    </Button>
                    <Button
                      className="Master_Card_Filter_Button"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <CloudDownloadOutlinedIcon
                          sx={{
                            color: "#344054",
                          }}
                        />
                      }
                      size="small"
                      variant="outlined"
                    >
                      <CSVLink
                        style={{ textDecoration: "none", color: "inherit" }}
                        {...csvFile}
                      >
                        Export
                      </CSVLink>
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Grid
                  item
                  marginLeft={2}
                  margin={1}
                  sx={{
                    backgroundColor: "#F0F5FA",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    padding: "2px",
                    paddingRight: "15px",
                    paddingLeft: "15px",
                    gap: "10px",
                    border: "1px solid #DFE7F1",
                  }}
                >
                  <Grid>
                    <img src={wallett} width="18px" height="17px" />
                  </Grid>
                  <Grid>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: "500",
                        color: "#1E3A5F",
                        fontSize: 16,
                        lineHeight: "1.2",
                      }}
                    >
                      ₹ {calculateSum(totalWallet?.map((value) => value))}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: "500",
                        color: "#667085",
                        fontSize: 12,
                        lineHeight: "1.2",
                      }}
                    >
                      Total Wallet
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={4} md={3.1} margin={1}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={(e) => {
                      onSearch(e);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search in Access"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={visibleRows}
                columns={headCells}
                handleMultiDelete={handleMultiDelete}
                loading={openLoader}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      {/* <Loader open={openLoader} /> */}
      <Drawer
        open={openDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: "100%" } },
        }}
      >
        {openDrawer ? (
          <ManageWallet
            setOpenDrawer={setOpenDrawer}
            selectedData={selectedData}
            formType={selectedData?._id ? "edit" : "add"}
            GetData={GetData}
            startDate={selectedStartDate}
            endDate={endDate}
            totalWallet={totalWallet}
            calculateSum={calculateSum}
          />
        ) : null}
      </Drawer>
    </>
  );
};
export default CompanyWallet;
